// Vendor
var $ = require("jquery");
var _ = require("lodash");
require("bootstrap");
require("chosen-js");
require("slick-carousel");

// Project
require("../../core/js/forms");
require("../../educators/js/educatorsCategoryFilters");
var HeroSlideshow = require("../../slideshow/js/heroSlideshow");
var ReviewSlideshow = require("../../slideshow/js/reviewSlideshow");
var Navigation = require("../../navigation/js/navigation");
var MobileMenu = require("../../navigation/js/mobileMenu");
var Overlay = require("../../overlay/js/overlay");
var GoogleMap = require("../../map_and_directions/js/googleMap");
var EventCalender = require("../../events/js/eventCalendar");

var selectors = {
    searchOverlay: "[data-search-overlay]",
    heroSlideshow: "[data-slideshow-hero]",
    reviewSlideshow: "[data-slideshow-review]",
    directionsMap: "[data-directions-map]",
    eventCalendar: "[data-event-calendar]"
};

new Navigation();
new MobileMenu();
new Overlay(selectors.searchOverlay);
new HeroSlideshow(selectors.heroSlideshow);
new ReviewSlideshow(selectors.reviewSlideshow);
new GoogleMap(selectors.directionsMap).render();

// NOTE: Timeout fixes an intermittent bug where scroll fails unexpectedly.
//       And from a UX perspective it's less disruptive visually...
var cal = new EventCalender(selectors.eventCalendar, {
    renderImmediately: false
});
setTimeout(function() {
    cal.render();
}, 700);



//////////////////
// WEBPACK FOOTER
// ./entry_points/js/index.js
// module id = 130
// module chunks = 3